import Advertisement from ".";
import ManageAd from "../../../../components/sections/admin/Advertisement/ManageAd";

export const advertisementRoutes = () => [
  {
    path: "/admin/advertisement",
    title: "Advertisement Management",
    layout: "admin",
    routeType: "admin",
    component: Advertisement,
  },
  {
    path: "/admin/manage-advertisement",
    component: ManageAd,
    layout: "admin",
    routeType: "admin",
    title: "Manage Ad",
  },
  {
    path: `/admin/manage-advertisement/:id`,
    component: ManageAd,
    layout: "admin",
    routeType: "admin",
    title: "Manage Ad",
  },
]